module.exports = __webpack_public_path__ + "static/media/3.9ef565eb.JPG";